import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
// ------ Services ------ //
import * as leadCaptureService from '../../../services/leadCaptureService'
// ------ Styles ------ //
import styles from './LicenseManager.module.css'
// ------ Components ------ //
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LicenseItem from '../../../components/LeadCapture/LicenseManager/LicenseItem'

const LicenseManager = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const leadCapture = location.state
    const [loaded, setLoaded] = useState(false)
    const [licenses, setLicenses] = useState([])
    const deactivateLicense = async (e) => {
        let id = e.currentTarget.id;
        let licensesList = await leadCaptureService.deactivateLicense(id);
        if (licensesList && licensesList.length > 0) {
            setLicenses(licensesList);
        }
    };
    const activateLicense = async (e) => {
        let id = e.currentTarget.id;
        let licensesList = await leadCaptureService.activateLicense(id);
        if (licensesList && licensesList.length > 0) {
            setLicenses(licensesList);
        }
    };
    const fetchLicenses = async (id) => {
        let licensesList = await leadCaptureService.getLeadCaptureLicenses(leadCapture.leadCaptureId);
        if (licensesList && licensesList.length > 0) {
            setLicenses(licensesList);
        }
        setLoaded(true);
    };

    useEffect(() => {
        fetchLicenses();

    }, [])
    return (
        <div id={styles.eventConfigurePage}>
            <h1>License Management</h1><br />
            <h2>Mobile App licenses for {leadCapture.leadCaptureName}.</h2><br />
            <>
                {
                    !loaded ? <LoadingSpinner /> :
                        <>
                            <br />
                            <table className={styles.tableLicenses}>
                                <thead>
                                    <tr className={styles.trLicenses}>
                                        <th className={styles.thLicenses}>
                                            ExhibitorId(RefNumber)  
                                            <HoverButton
                                                title={'Exhibitor id'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Exhibitor
                                            <HoverButton
                                                title={'Exhibitor name'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Email
                                            <HoverButton
                                                title={'Email/login string used'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            License Key
                                            <HoverButton
                                                title={'License key'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Active
                                            <HoverButton
                                                title={'Flag for license usage'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Created Date
                                            <HoverButton
                                                title={'Date of first login'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Last Login Date
                                            <HoverButton
                                                title={'Date of last login'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            License Order
                                            <HoverButton
                                                title={'Counter for license usage'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>
                                            Max Allowed Licenses
                                            <HoverButton
                                                title={'Max allowed licenses count'}
                                                messageWidth={75}
                                            />
                                        </th>
                                        <th className={styles.thLicenses}>User Actions
                                            <HoverButton
                                                title={'User options'}
                                                messageWidth={75}
                                            /></th>
                                    </tr>
                                </thead>
                                <tbody key={licenses.length}>
                                    {licenses.map((item, index) => (
                                        <LicenseItem
                                            index={index}
                                            license={item}
                                            deactivateLicense={deactivateLicense}
                                            activateLicense={activateLicense}
                                            >
                                        </LicenseItem>
                                    ))}
                                </tbody>

                            </table>
                        </>
                }
            </>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default LicenseManager;